import UibookCase from 'uibook/case'
import React from 'react'
import TelegramChip from '../TelegramChip'

const MODES = ['elevated', 'mono', 'outline']

const I18N = {
  ru: {
    title: {
      elevated: 'Elevated чип',
      mono: 'Mono чип',
      outline: 'Outline чип',
    },
    hint: {
      elevated: 'Приподнятый чип для важных фильтров.',
      mono: 'Нейтральный чип для спокойных меток.',
      outline: 'Контурный чип для вторичных действий.',
    }
  },
  en: {
    title: {
      elevated: 'Elevated chip',
      mono: 'Mono chip',
      outline: 'Outline chip',
    },
    hint: {
      elevated: 'Raised chip for highlighted filters.',
      mono: 'Neutral chip for calm labels.',
      outline: 'Outlined chip for secondary actions.',
    }
  }
}

const PROPS = {
  onClick: UibookCase.event('onTelegramChipModeClick')
}

export default {
  background: 'light',
  component: TelegramChip,
  i18n: true,
  cases: MODES.map(mode => locale => <UibookCase props={{
    ...PROPS,
    mode: mode,
    description: I18N.en.hint[mode]
  }}>
    { I18N[locale].title[mode] }
  </UibookCase>)
}
